var map = {
	"./HideBusiness/HideBusiness.loadable.js": 68232,
	"./PriceList/PriceList.loadable.js": 60552,
	"./ServiceAdd/ServiceAdd.loadable.js": 26789,
	"./ServiceList/ServiceList.loadable.js": 53750,
	"./ServiceSettings/ServiceSettings.loadable.js": 37756
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 79107;